import { MouseEvent } from "react";
import { logout as signOut } from "../../ApiService/admin/Account";
import { getCurrentAdmin } from "../../ApiService/auth";
import HeaderNotifications from "./HeaderNotifications";
import { useAdminLang } from "./i18n";

// Converted 1:1 from the Xintra template (index.html, main-header).
// Behaviour (dropdowns, theme toggle, sidebar toggle, search, fullscreen) comes
// from the template scripts loaded in AdminLayout — no React handlers here.
const prevent = (e: MouseEvent) => e.preventDefault();

export default function AdminHeader() {
  const { t, lang, setLang } = useAdminLang();
  const admin = getCurrentAdmin();
  // revoke the refresh token on the server, then go to the login page
  const logout = (e: MouseEvent) => {
    e.preventDefault();
    signOut().finally(() => window.location.assign("/login"));
  };

  return (
    <header className="app-header sticky" id="header">
      <div className="main-header-container container-fluid">
        <div className="header-content-left">
          <div className="header-element">
            <div className="horizontal-logo">
              <a href="/admin" className="header-logo">
                <img src="/assets/images/brand-logos/desktop-logo.png" alt="logo" className="desktop-logo" />
                {" "}
                <img src="/assets/images/brand-logos/toggle-dark.png" alt="logo" className="toggle-dark" />
                {" "}
                <img src="/assets/images/brand-logos/desktop-dark.png" alt="logo" className="desktop-dark" />
                {" "}
                <img src="/assets/images/brand-logos/toggle-logo.png" alt="logo" className="toggle-logo" />
                {" "}
                <img src="/assets/images/brand-logos/toggle-white.png" alt="logo" className="toggle-white" />
                {" "}
                <img src="/assets/images/brand-logos/desktop-white.png" alt="logo" className="desktop-white" />
              </a>
            </div>
          </div>
          <div className="header-element mx-lg-0 mx-2">
            <a aria-label="Hide Sidebar" className="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle" data-bs-toggle="sidebar" href="#" onClick={prevent}>
              <span></span>
            </a>
          </div>
          <div className="header-element header-search d-md-block d-none my-auto auto-complete-search">
            <input type="text" className="header-search-bar form-control" id="header-search" placeholder={t("جستجو")} spellCheck="false" autoComplete="off" autoCapitalize="off" />
            {" "}
            <a href="#" onClick={prevent} className="header-search-icon border-0">
              <i className="ri-search-line"></i>
            </a>
          </div>
        </div>
        <ul className="header-content-right">
          <li className="header-element d-md-none d-block">
            <a href="#" onClick={prevent} className="header-link" data-bs-toggle="modal" data-bs-target="#header-responsive-search">
              <i className="bi bi-search header-link-icon d-flex"></i>
            </a>
          </li>
          <li className="header-element country-selector dropdown">
            <a href="#" onClick={prevent} className="header-link dropdown-toggle" data-bs-auto-close="outside" data-bs-toggle="dropdown">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 header-link-icon" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802"></path>
              </svg>
            </a>
            <ul className="main-header-dropdown dropdown-menu dropdown-menu-end" data-popper-placement="none">
              <li>
                <a className={`dropdown-item d-flex align-items-center ${lang === "fa" ? "active" : ""}`} href="#" onClick={(e) => { e.preventDefault(); setLang("fa"); }}>
                  <span className="avatar avatar-rounded avatar-xs lh-1 me-2">
                    <img src="/assets/images/flags/iran_flag.svg" alt="img" />
                  </span>
                  {" "}فارسی
                </a>
              </li>
              <li>
                <a className={`dropdown-item d-flex align-items-center ${lang === "en" ? "active" : ""}`} href="#" onClick={(e) => { e.preventDefault(); setLang("en"); }}>
                  <span className="avatar avatar-rounded avatar-xs lh-1 me-2">
                    <img src="/assets/images/flags/us_flag.jpg" alt="img" />
                  </span>
                  {" "}English
                </a>
              </li>
            </ul>
          </li>
          <li className="header-element header-theme-mode">
            <a href="#" onClick={prevent} className="header-link layout-setting">
              <span className="light-layout">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 header-link-icon" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"></path>
                </svg>
              </span>
              {" "}
              <span className="dark-layout">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 header-link-icon" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"></path>
                </svg>
              </span>
            </a>
          </li>
          <HeaderNotifications />
          <li className="header-element header-fullscreen">
            <a href="#" onClick={(e) => { e.preventDefault(); (window as any).openFullscreen?.(); }} className="header-link">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 full-screen-open header-link-icon" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"></path>
              </svg>
              {" "}
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 full-screen-close header-link-icon d-none" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25"></path>
              </svg>
            </a>
          </li>
          <li className="header-element dropdown">
            <a href="#" onClick={prevent} className="header-link dropdown-toggle" id="mainHeaderProfile" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
              <div className="d-flex align-items-center">
                <div>
                  <span className="avatar avatar-sm bg-primary text-fixed-white fw-semibold">
                    {(admin?.userName || "A").charAt(0).toUpperCase()}
                  </span>
                </div>
              </div>
            </a>
            <ul className="main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end" aria-labelledby="mainHeaderProfile">
              <li>
                <div className="dropdown-item text-center border-bottom">
                  <span dir="ltr">{admin?.userName || t("مدیر")}</span>
                  {" "}
                  <span className="d-block fs-12 text-muted" dir="ltr">{admin?.email}</span>
                </div>
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" href="/admin/about">
                  <i className="fe fe-user p-1 rounded-circle bg-primary-transparent me-2 fs-16"></i>
                  {t("حساب کاربری")}
                </a>
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" href="/admin/messages">
                  <i className="fe fe-mail p-1 rounded-circle bg-primary-transparent me-2 fs-16"></i>
                  {t("ایمیل")}
                </a>
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" href="/admin/users">
                  <i className="fe fe-users p-1 rounded-circle bg-primary-transparent klist me-2 fs-16"></i>
                  {t("کاربران")}
                </a>
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" href="#" onClick={prevent}>
                  <i className="fe fe-settings p-1 rounded-circle bg-primary-transparent ings me-2 fs-16"></i>
                  {t("تنظیمات")}
                </a>
              </li>
              <li className="border-top bg-light">
                <a className="dropdown-item d-flex align-items-center" href="/admin/messages">
                  <i className="fe fe-help-circle p-1 rounded-circle bg-primary-transparent set me-2 fs-16"></i>
                  {t("پشتیبانی")}
                </a>
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" href="/login" onClick={logout}>
                  <i className="fe fe-lock p-1 rounded-circle bg-primary-transparent ut me-2 fs-16"></i>
                  {t("خروج")}
                </a>
              </li>
            </ul>
          </li>
          <li className="header-element">
            <a href="#" onClick={prevent} className="header-link switcher-icon" data-bs-toggle="offcanvas" data-bs-target="#switcher-canvas">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 header-link-icon" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"></path>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"></path>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
}
